import { render, staticRenderFns } from "./CollectedData.vue?vue&type=template&id=f00f797e&scoped=true&"
import script from "./CollectedData.vue?vue&type=script&lang=ts&"
export * from "./CollectedData.vue?vue&type=script&lang=ts&"
import style0 from "./CollectedData.vue?vue&type=style&index=0&id=f00f797e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00f797e",
  null
  
)

export default component.exports